import React, { Fragment, useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import i18n from '../../i18n';
import { setLanguage } from '../../redusers/languageReducer';
import { getNextYear, setCookie } from '../../utils';

const LanguageSwitcher = () => {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);

    const currentLanguage = useSelector(state => state.language.currentLanguage);

    const changeLanguage = language => {
        setCookie('Exadel.EIS.Language', language, {
            expires: new Date(getNextYear())
        });
        dayjs.locale(language);
        i18n.changeLanguage(language); // Меняем язык в i18next
        dispatch(setLanguage(language)); // Обновляем язык в Redux
        setAnchorEl(null);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const languages = [
        { name: 'English', code: 'en' },
        { name: 'Русский', code: 'ru' }
    ];

    return (
        <Fragment>
            <Button
                color="inherit"
                aria-label="Menu"
                aria-owns={anchorEl ? 'simple-menu' : null}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <LanguageIcon style={{ paddingRight: 8 }} />
                {currentLanguage || ''}
            </Button>
            <Menu
                disableAutoFocusItem
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {languages.map(lang => (
                    <MenuItem
                        key={lang.code}
                        onClick={() => changeLanguage(lang.code)}
                    >
                        {lang.name}
                    </MenuItem>
                ))}
            </Menu>
        </Fragment>
    );
};

export default LanguageSwitcher;
